module.exports = __webpack_public_path__ + "70d84edd86ddbb992949cd89b6d91efd.pdf";